// src/services/authService.js
import { auth, db } from "../firebase";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  signOut,
  updateProfile,
  sendPasswordResetEmail,
  // sendEmailVerification, <--- BURADAN KALDIRDIK (Artık index.js halledecek)
  reauthenticateWithCredential,
  EmailAuthProvider,
  updatePassword
} from "firebase/auth";
import { doc, setDoc, getDoc } from "firebase/firestore"; 

export const authService = {
  // 1. Kayıt Ol
  register: async (email, password, name, surname, phone, marketingConsent, legalData) => {
    try {
      const userCredential = await createUserWithEmailAndPassword(auth, email, password);
      const user = userCredential.user;

      await updateProfile(user, { displayName: `${name} ${surname}` });

      // YENİ: marketingConsent ve legalData (Hukuki Loglar) bilgisini veritabanına yazdırıyoruz
      await setDoc(doc(db, "users", user.uid), {
        uid: user.uid,
        email: email,
        name: name,
        surname: surname,
        phone: phone,
        role: "user", // Yeni üyeler user rolüyle başlar
        marketingConsent: marketingConsent || false, 
        legalApprovals: legalData || {}, // YASAL ZIRH: Onay saatleri ve cihaz bilgileri
        createdAt: new Date(),
      });

      // 🔥 ÇÖZÜM: await sendEmailVerification(user); SATIRI SİLİNDİ!
      // Çünkü Firebase'in sıkıcı maili yerine, index.js üzerinden şık Hoş Geldin mailimiz gidecek!

      return user;
    } catch (error) {
      console.error("Kayıt hatası:", error);
      throw error;
    }
  },

  // 2. Giriş Yap
  login: async (email, password) => {
    try {
      const userCredential = await signInWithEmailAndPassword(auth, email, password);
      return userCredential.user;
    } catch (error) {
      console.error("Giriş hatası:", error);
      throw error;
    }
  },

  // 3. Çıkış Yap
  logout: async () => {
    try {
      await signOut(auth);
    } catch (error) {
      console.error("Çıkış hatası:", error);
      throw error;
    }
  },

  // 4. Şifre Sıfırlama
  resetPassword: async (email) => {
    try {
      await sendPasswordResetEmail(auth, email);
    } catch (error) {
      console.error("Şifre sıfırlama hatası:", error);
      throw error;
    }
  },

  // 5. Veri Çekme
  getUserData: async (uid) => {
    try {
      const docRef = doc(db, "users", uid);
      const docSnap = await getDoc(docRef);
      return docSnap.exists() ? docSnap.data() : null;
    } catch (error) {
      console.error("Kullanıcı verisi çekme hatası:", error);
      throw error;
    }
  },

  // 6. Profil/Adres Güncelleme
  updateUserData: async (uid, data) => {
    try {
      const userRef = doc(db, "users", uid);
      await setDoc(userRef, data, { merge: true });
    } catch (error) {
      console.error("Profil güncelleme hatası:", error);
      throw error;
    }
  },

  // 7. Şifre Değiştirme
  changePassword: async (user, currentPassword, newPassword) => {
    try {
      const credential = EmailAuthProvider.credential(user.email, currentPassword);
      await reauthenticateWithCredential(user, credential);
      await updatePassword(user, newPassword);
    } catch (error) {
      console.error("Şifre değiştirme hatası:", error);
      throw error;
    }
  }
};